import { SliderBase } from './SliderBase';

class SliderPagination {
	private readonly paginationContainer: HTMLElement;
	private readonly pagination: boolean;
	private paginationItems: NodeListOf<HTMLElement>;
	private slider: SliderBase;
	private paginationOffset: number;

	constructor(instance: SliderBase) {
		this.slider = instance;
		this.paginationContainer = this.slider.config.target.parentNode.querySelector(
			'.scroll-slider-pagination'
		);
		this.pagination = this.paginationContainer !== null;

		if (this.hasPagination) {
			this.paginationOffset = this.getPaginationOffset();
			window.addEventListener('resize', () => this.handleResize(), { passive: true });
		}
	}

	public get hasPagination(): boolean {
		return this.pagination;
	}

	public initPagination(): void {
		if (!this.hasPagination) {
			return;
		}

		this.paginationContainer.innerHTML = '';

		let numBullets: number;

		if (this.slider.itemsPerView > 1) {
			numBullets = Math.ceil(this.slider.totalItems / this.slider.itemsPerView);
		} else {
			numBullets = this.slider.totalItems - this.paginationOffset;
		}

		let bullet: HTMLElement;

		for (let i: number = 0; i < numBullets; i++) {
			bullet = document.createElement('span');
			bullet.classList.add('bullet');
			bullet.addEventListener('click', () => {
				this.slider.currentItem = i * this.slider.itemsPerView;
				this.slider.scrollToCurrentItem();
			});

			this.paginationContainer.appendChild(bullet);
		}

		this.paginationItems = this.paginationContainer.querySelectorAll('.bullet');
	}

	public updatePagination(): void {
		if (!this.hasPagination) {
			return;
		}

		const current: number = Math.ceil(this.slider.currentItem / this.slider.itemsPerView);

		this.paginationItems.forEach((bullet: HTMLElement, index: number) => {
			if (index === current) {
				bullet.classList.add('active');
			} else {
				bullet.classList.remove('active');
			}
		});
	}

	private handleResize(): void {
		const paginationOffset: number = this.getPaginationOffset();

		if (this.paginationOffset !== paginationOffset) {
			this.paginationOffset = paginationOffset;
			this.initPagination();
		}
	}

	private getPaginationOffset(): number {
		if (this.slider.itemsPerView === 1) {
			return 0;
		}

		const style: CSSStyleDeclaration = getComputedStyle(this.slider.wrapper);
		const containerWidth: number =
			this.slider.wrapper.offsetWidth -
			parseInt(style.paddingLeft, 10) -
			parseInt(style.paddingRight, 10);
		let itemsPerView: number = 0;

		this.slider.items.forEach((item: HTMLElement) => {
			if (item.offsetLeft < containerWidth) {
				itemsPerView++;
			}
		});

		return itemsPerView - 1;
	}
}

export { SliderPagination };
